import { connect } from 'react-redux'
import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import './app.css'
import ContentPane from './ContentPane'
import { getUploads } from '../misc/selectors'
import Navbar from '../nav/Navbar'
import { processUploadedFiles } from '../misc/utilities'
import TwitterIcon from 'react-icons/lib/ti/social-twitter'
import InstagramIcon from 'react-icons/lib/ti/social-instagram'
import Cookies from 'js-cookie'

const mapStateToProps = (state, ownProps) => ({
  viewParams: ownProps.viewParams,
  me: state.me,
  uploads: getUploads(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  onDrop: (acceptedFiles, rejectedFiles) => {
    if (!acceptedFiles.length) {
      return
    }
    let group = null
    if (ownProps.viewParams.view === 'album') {
      group = ownProps.viewParams.shortcode
    }

    processUploadedFiles(dispatch, acceptedFiles, group)
  },
})

class App extends Component {
  constructor() {
    super()
    this.closeHandler = (event) => {
      if (this.props.uploads.filter(x => x.status < 2).length) {
        return event.returnValue = 'Your video is currently uploading. Are you sure you want to leave?'
      }
    }
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.closeHandler.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.closeHandler)
  }

  componentWillReceiveProps(nextProps) {
    window.ga('set', 'metric1', this.props.me.embed_plays || 0);
    window.ga('set', 'metric2', this.props.me.total_plays || 0);
    window.ga('set', 'dimension2', this.props.me.user_name);
    window.ga('set', 'userId', this.props.me.user_name);
  }

  render() {
    return (

      <Dropzone
        accept="video/*"
        ref="dropzone"
        onDrop={this.props.onDrop}
        noClick
        disabled={this.props.viewParams.view === 'settings'}
      >
        {({getRootProps, getInputProps, isDragActive}) => (
        <div 
          className={`app-container ${this.props.me.dark_mode ? 'dark' : ''} ${isDragActive ? 'drop-accepted' : ''}`} 
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          <Navbar viewParams={this.props.viewParams} rootUrl={this.props.viewParams.query ? this.props.viewParams.query.rootUrl : null} key="navbar" />
          <div className="main-content">
            <ContentPane viewParams={this.props.viewParams} />
          </div>
          <div className="main-footer">
            <ul className="nav nav-pills nav-stacked nav-bottom">
              <li className="terms-footer">
                <a href="https://terms.streamable.com/">Terms</a>
                <a href="https://privacy.streamable.com/">Privacy</a>
                <a href="https://support.streamable.com/">Support</a>
                <a href="https://api.streamable.com/">API</a>
                <a href="#" style={{visibility: window.DRIFT_API ? 'visible': 'hidden'}} id="drift-toggle" onClick={(e) => {
                  e.preventDefault();
                  window.DRIFT_API.sidebar.open()
                }}>Chat with us</a>
              </li>
            </ul>
          </div>
        </div>
        )}
      </Dropzone>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App)
